//page contants
export const OVERALL="OVERALL"
export const VARIATION= "VARIATION"
export const SCENARIO= "SCENARIO"

//global param contants
export const TESTRUNID= "TEST_RUN_ID"
export const EXECUTIONID="EXECUTION_ID"